import React from "react"
import { useDispatch, useSelector } from "react-redux"

import { AutoComplete } from "components/AutoComplete"
import { SET_SELECTED_DEPARTMENT, ME_UPDATE } from "store/actions"

import {
    useLocation,
    useParams,
} from "react-router-dom/cjs/react-router-dom.min"
import { APP_ROUTES, getRoute } from "helpers/routeHelpers"
import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"

const DepartmentSelection = () => {
    const location = useLocation()
    const { itemId } = useParams()
    const isDisable =
        location.pathname ==
        getRoute(APP_ROUTES.INVENTORY_BREAKDOWN, { itemId: itemId })
    const store = useSelector(state => state)
    const dispatch = useDispatch()

    const handleSelectOptionDepartment = option => {
        dispatch({ type: SET_SELECTED_DEPARTMENT, payload: option })
    }

    const generateOptions = () => {
        let options = store?.userAuth?.user?.departmentAssignments?.map(
            item => ({
                label: item?.department?.departmentName,
                value: item?.department?.id,
                ...item,
            })
        )
        options.unshift({
            label: "All Stations",
            value: "all",
        })

        return options
    }

    return (
        <div className="">
            <AutoComplete
                isDisabled={isDisable}
                isSearchable
                value={store.departmentConfig.currentSelectedDepartment}
                placeholder="Change Stage"
                customStyles={autoCompleteStyles.STYLE_ONE}
                onChange={val => handleSelectOptionDepartment(val)}
                // classNamePrefix="status-header-search"
                options={generateOptions()}
            />
        </div>
    )
}

export default DepartmentSelection
